/* src/app/umbrella-common/components/checklist-accordion/checklist-accordion.style.scss */
.accordion .accordion-header {
  display: flex;
  max-width: 383px;
  width: 383px;
  margin-top: 40px;
}
.accordion .accordion-header h6.accordion-title {
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 1.33;
  color: #007d40;
  margin-top: auto;
  margin-bottom: 15px;
}
.accordion .accordion-header .toggle-accordion {
  cursor: pointer;
  margin-top: auto;
  margin-bottom: 22px;
  margin-left: auto;
}
.accordion .accordion-header .toggle-accordion nb-icon {
  position: relative;
  top: 2px;
}
/*# sourceMappingURL=checklist-accordion.style.css.map */
